import './index.less';

import {
  Button,
  Form,
  Input,
  message
} from 'antd';

import React from 'react';
import UiModal from "../../components/modalForm/UiModal";
import { encryptVigenere } from '../../utils/helper'
import { expiredModifyPwd } from 'api/user';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};
const FormItem = Form.Item;


@Form.create()

export default class ResetPwd extends React.Component {
  constructor(props) {
    super(props);

  }

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('newPasswd')) {
      callback('密码输入要相同!');
    } else {
      callback();
    }
  };

  handleSubmit = (e) => {
    e && e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      const encryptVigenerePassword_old = encryptVigenere(values.oldPasswd)
      const encryptVigenerePassword_new = encryptVigenere(values.confirm)
      if (!err) {
        expiredModifyPwd({ oldPasswd: encryptVigenerePassword_old, newPasswd: encryptVigenerePassword_new, loginUniqueKey: this.props.loginUniqueKey }).then(res => {
          if (res.code === 200) {
            message.info('修改成功');
            this.props.onCancel();
          } else {
            message.error(res.msg);
          }
        })
      }
    });

  };

  refresh = () => {
    this.props.form.resetFields();
  };


  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <UiModal
        visible={this.props.visible}
        title='修改密码'
        modalKey='look'
        onCancel={this.props.onCancel}
        footer={null}
        destroyOnClose={true}
        className={'form-modal reset-self-modal'}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="旧密码"
          >
            {getFieldDecorator('oldPasswd', {
              rules: [{
                min: 8,
                max: 20,
                required: true,
                message: '密码必须为8到20位!',
              }]
            })(
              <Input.Password />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="新密码"
          >
            {getFieldDecorator('newPasswd', {
              rules: [{
                min: 8,
                max: 20,
                required: true,
                message: '密码必须为8到20位!',
              }, {
                pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/,
                message: '密码必须包含大写字母、小写字母、数字、特殊符号，并且至少8位',
              }]
            })(
              <Input.Password />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="确认新密码"
          >
            {getFieldDecorator('confirm', {
              rules: [{
                required: true, message: '请确认你的密码是否一致!',
              }, {
                validator: this.compareToFirstPassword,
              }],
            })(
              <Input.Password />
            )}
          </FormItem>
          <FormItem
            key="control-buttons"
          >
            <div className="buttons">
              <Button className='modal-button' onClick={this.refresh}>重置</Button>
              <Button className='modal-button' onClick={this.props.onCancel}>取消</Button>
              <Button className='modal-button save-button' type="primary"
                htmlType="submit">确定</Button>
            </div>

          </FormItem>
        </Form>
      </UiModal>

    );
  }

  static defaultProps = {
    visible: false,
    onCancel: () => null,
    styleName: ''
  };
}



